import $api from "../../axios"
import { AxiosResponse } from "axios"

const api = `/sp/campaignsSkc/`
const settingApi = `/setting/`
const filterApi = `/filter/`

const ApiPlacementList = (data) => {
  return $api
    .post(`${api}getPlacement`, data)
    .then((res) => res.data)
    .catch((res) => res.data)
}

const ApiPlacementListMange = (data) => {
  return $api.post(`${settingApi}getUnmanagedCampaign`, data).then((res) => res.data)
}

const ApiFilterList = (data) => {
  return $api.post(`${filterApi}getAllFilter`, data).then((res) => res.data)
}

const ApiCustomFilter = (data) => {
  return $api
    .post(`${filterApi}getAllFilterWithOutPagination`, data)
    .then((res) => res.data)
    .catch((res) => res.data)
}

const ApiChild = (data) => {
  return $api
    .post(`${api}getChildData`, data)
    .then((res) => res.data)
    .catch((res) => res.data)
}

const ApiUnmanage = (data) => {
  return $api.post(`${settingApi}updateUnmanagedCampaign`, data).then((res) => res.status)
}

const ApiOrderSave = (data): Promise<AxiosResponse<unknown>> => {
  return $api.post(`${api}saveDefaultOrder`, data)
}

const ApireverseBidChange = (data) => {
  return $api.post(`${api}reverseBidChange`, data).then((res) => res.data)
}

export {
  ApiPlacementListMange,
  ApiOrderSave,
  ApiUnmanage,
  ApiCustomFilter,
  ApiPlacementList,
  ApiFilterList,
  ApiChild,
  ApireverseBidChange,
}
